{
    "GenericFooter_ServerErrorTitle": "Erros de validação",
    "GenericFooter_ValidationWarning": "Certifique-se de que todos os campos estão corretamente preenchidos",
    "GenericFooter_ButtonHelpLabel": "Ajuda?",
    "GenericFooter_ButtonSubmitLabel": "Guardar",
    "GenericFooter_ButtonCancelLabel": "Cancelar",
    "NAME": "GenericFooter"
}